<template>
<div>
  <b-card>
    <grid-filters grid-data="dsrPointsMonthGrid" :fields="gridFilters" ></grid-filters>
    <div class="text-right mb-3">
      <b-button variant="success" class="text-white" :disabled="exporting" v-on:click="exportGrid()"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button>
    </div>
    <Grid ref="dsrPointsMonthGrid" name="dsrPointsMonthGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      gridFilters: [{
        field:'ym',
        type: 'date',
        placeholder: 'AnoMês (YYYYMM)',
        val: ''
      }, {
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      url: 'dsr/points_monthly',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      columns: [{
        field: 'dsr_id',
        title: 'DSR Id',
        width: '80px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '120px'
      }, {
        field: 'first_name',
        title: 'Nome próprio',
        width: '120px'
      },
      {
        field: 'last_name',
        title: 'Apelido',
        width: '120px'
      },
      {
        field: 'username',
        title: 'Utilizador',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '120px',
        values: []
      }, {
        field: 'points_total',
        title: 'Pts DSR',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'leader_points',
        title: 'Pts Leader',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'extra',
        title: 'Pts Extra',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'site',
        title: 'Pts Formações',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'spent',
        title: 'Pts Gastos',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'grand_total',
        title: 'Pts',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'ola',
        title: 'Pts Olá',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.dsrPointsMonthGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post(this.url + '/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'dsr_points.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('dsr_points.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
